module.exports = __webpack_public_path__ + "static/media/MV.723df69d.png";